import React, { PureComponent } from 'react';

import { ROLE_IDS_TO_HUMAN_READABLE } from '../../support/accessControlConstants';
import { getResourceText } from '../../support/utils/accessControlHelpers';

export default class ForbiddenView extends PureComponent {
  render() {
    const resourceText = getResourceText(this.props.accessResources);

    const role = ROLE_IDS_TO_HUMAN_READABLE[this.props.role] || 'Custom';
    return (
      <div className="flex-layout__screen">
        <div
          data-testid="forbidden-view__container"
          className="forbidden-view__container"
        >
          <img
            className="forbidden-view__image"
            src="/static/images/locked.svg"
          />
          <div className="forbidden-view__title">
            You do not have access to this page
          </div>
          {!this.props.loading && (
            <div>
              <span>{`You need access to `}</span>
              <span className="h_fw-500">{resourceText}</span>
              <span>{` to see this page. Currently you have `}</span>
              <span className="h_fw-500 h_c-info">{role}</span>
              <span>{` access to this account, which does not include these permissions. Please contact your administrator for access or more information.`}</span>
            </div>
          )}
        </div>
      </div>
    );
  }
}
